import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getAccountStatus } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function fetchAccountStatus(): Promise<APIResult> {
  const response = await fetch(getAccountStatus, {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type APIResult = {
  Data: Array<{
    Id: number;
    Description: string;
  }>;
  IsSuccess: boolean;
  StatusCode: number;
};

type TResult = Array<{
  id: number;
  name: string;
}>;

function useGetAccountStatus(): UseQueryResult<TResult, TError> {
  return useQuery(
    'get_account_status',
    async () => {
      const fetchResponse = await fetchAccountStatus();
      const result = fetchResponse?.Data?.map(item => ({
        id: item.Id,
        name: item.Description,
      }));
      return result;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetAccountStatus };
